/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import axios from "axios";
import AuthManager from "../../utils/AuthManager";

export const API_DOMAIN_NAME =
  process.env.NODE_ENV === "production"
    ? "api.lssquare.com"
    : "lsquare-api.sandbox.alpstein.my";

export const AUTH_TOKEN_HEADER = "x-lsquare-token";

const API_URL = `https://${API_DOMAIN_NAME}`;

/**
 * Axios Api Instance Configuration
 * @type {AxiosInstance}
 */
function createInstance() {
  const instance = axios.create({
    baseURL: API_URL,
    timeout: 30000 /** HttpTimeout:30sec **/,
    headers: {
      "Content-Type": "application/json"
    }
  });

  instance.interceptors.request.use(config => {
    config.headers[AUTH_TOKEN_HEADER] = AuthManager.retrieveToken();
    config.headers["Accept-Language"] = AuthManager.retrieveUserLanguage()
      ? AuthManager.retrieveUserLanguage()
      : "en";

    return config;
  });

  return instance;
}

const apiInstance = createInstance();

export default apiInstance;



// WEBPACK FOOTER //
// ./src/services/httpUtilities/httpManager.js